import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css'; 
import 'select2-theme-bootstrap4/dist/select2-bootstrap.css'; 

$(() => {
  $('.select2').select2({
    theme: "bootstrap",
  });
  $('.select2-4').select2({
    theme: "bootstrap4",
  });
})

function showUploadAlert(type, message) {
  var alertClass = type === 'success' ? 'success' : 'danger'
  var $alert = $(
    '<div class="alert alert-' + alertClass + ' alert-dismissible fade show" role="alert" style="margin-top: 20px;">' +
      '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
      '</button>' +
      '<div>' + message + '</div>' +
    '</div>'
  )
  var $status = $('#status')
  $status.html($alert)
  if (type === 'success') {
    setTimeout(function () {
      $alert.alert('close')
    }, 5000)
  }
  if ($status.length && $status.offset()) {
    $('html, body').animate({ scrollTop: $status.offset().top - 80 }, 300)
  }
}

window.showUploadAlert = showUploadAlert

function formHasSelectedFile($form) {
  var hasFile = false
  $form.find('input[type="file"]').each(function () {
    if (this.files && this.files.length > 0) {
      hasFile = true
      return false
    }
  })
  return hasFile
}

function setUploadProgress($form, percent) {
  var $bar = $form.find('.js-upload-progress-bar')
  $bar.css('width', percent + '%').attr('aria-valuenow', percent).text(percent + '%')
  if (percent >= 100) {
    $form.find('.js-upload-progress-text').text('Memproses di server...')
  }
}

$(document).on('ajax:beforeSend', '.js-upload-form', function (event, xhr) {
  // Ignore bubbled ajax from child links (e.g. Hapus dokumen)
  if (event.target !== this) return

  var $form = $(this)

  if (!formHasSelectedFile($form)) {
    event.preventDefault()
    showUploadAlert('danger', 'Pilih file terlebih dahulu sebelum mengunggah.')
    return false
  }

  window._lastUploadLabel = $form.data('upload-label') || 'File'
  $form.find('[type="submit"]').prop('disabled', true)
  $form.find('.js-upload-progress').show()
  setUploadProgress($form, 0)

  if (xhr && xhr.upload) {
    xhr.upload.addEventListener('progress', function (e) {
      if (!e.lengthComputable) return
      var percent = Math.max(1, Math.min(99, Math.round((e.loaded / e.total) * 100)))
      setUploadProgress($form, percent)
    })
    xhr.upload.addEventListener('load', function () {
      setUploadProgress($form, 100)
    })
  } else {
    setUploadProgress($form, 100)
  }
})

$(document).on('ajax:error', '.js-upload-form', function (event) {
  if (event.target !== this) return

  var $form = $(this)
  $form.find('[type="submit"]').prop('disabled', false)
  $form.find('.js-upload-progress').hide()
  setUploadProgress($form, 0)
  showUploadAlert('danger', 'Upload gagal. Silakan coba lagi.')
  window._lastUploadLabel = null
})
